/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Ui_Gesture_LessInputs */

const en_us2_ui_gesture_less = /** @type {(inputs: Ui_Gesture_LessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Less ${i?.label}`)
};

const pt_br2_ui_gesture_less = /** @type {(inputs: Ui_Gesture_LessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Menos ${i?.label}`)
};

const es_419_ui_gesture_less = /** @type {(inputs: Ui_Gesture_LessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Menos ${i?.label}`)
};

const pt_pt2_ui_gesture_less = /** @type {(inputs: Ui_Gesture_LessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Menos ${i?.label}`)
};

const fr_fr2_ui_gesture_less = /** @type {(inputs: Ui_Gesture_LessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Moins de ${i?.label}`)
};

const de_de2_ui_gesture_less = /** @type {(inputs: Ui_Gesture_LessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Weniger ${i?.label}`)
};

const it_it2_ui_gesture_less = /** @type {(inputs: Ui_Gesture_LessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meno ${i?.label}`)
};

/**
* | output |
* | --- |
* | "Less {label}" |
*
* @param {Ui_Gesture_LessInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_gesture_less = /** @type {((inputs: Ui_Gesture_LessInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Gesture_LessInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_gesture_less(inputs)
	if (locale === "es-419") return es_419_ui_gesture_less(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_gesture_less(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_gesture_less(inputs)
	if (locale === "de-DE") return de_de2_ui_gesture_less(inputs)
	if (locale === "it-IT") return it_it2_ui_gesture_less(inputs)
	return en_us2_ui_gesture_less(inputs)
});
export { ui_gesture_less as "ui-gesture.less" }